import { dateDashesSetInstead, mobileHyphensSetInstead, ssnHyphensSetInstead } from 'src/app/core/helpers/app-link'
import { SESSION_TIMER_MINUTES } from '../../options-utils/modal-shared'
import { ModalOptionsFormComponent } from '../modal-options-form.component'
import { inputSelectAriaCheckActiveState, inputAriaCheckActiveStateSSN } from './inputs'
import { isPlatformBrowser } from '@angular/common'

// events & handlers

/**
 * set Enter / Tab  press event on inputs
 * @param i - index of element formControlsInputId
 */
function enterAndTabHandler(that: ModalOptionsFormComponent, event, i): void {
    if (!isPlatformBrowser(this.platformId)) {
    return;
  }
  if (event.key === 'Enter' || (event.key === 'Tab' && !event.shiftKey)) {
    that.logger.info('enter on input event')
    const nextId = that.formControlsInputId[i + 1]
    const el = document.getElementById(nextId)
    if (!el) {
      that.logger.info('no element')
      return
    }
    event.preventDefault()
    that.setRunTimerByTimeout(SESSION_TIMER_MINUTES)
    el.click()
    el.focus()
    if (nextId === 'ssnInputId') {
      inputAriaCheckActiveStateSSN(el.parentElement.parentElement, true)
      return
    }
    inputSelectAriaCheckActiveState(el.parentElement, true)
  }
}

/**
 * set Shift + Tab event on inputs
 * @param i - index of element formControlsInputId
 */
function shiftTabHandler(that: ModalOptionsFormComponent, event, i): void {
    if (!isPlatformBrowser(this.platformId)) {
    return;
  }
  if (event.key === 'Tab' && event.shiftKey) {
    that.logger.info('shift tab on input event')
    const nextId = that.formControlsInputId[i - 1]
    const el = document.getElementById(nextId)
    if (!el) {
      that.logger.info('no element')
      return
    }
    event.preventDefault()
    that.setRunTimerByTimeout(SESSION_TIMER_MINUTES)
    el.click()
    if (nextId === 'ssnInputId') {
      inputAriaCheckActiveStateSSN(el.parentElement.parentElement, true)
      return
    }
    inputSelectAriaCheckActiveState(el.parentElement, true)
  }
}

/**
 * just go to state as on shift tab
 *
 * go through all inputs and set
 *
 * keydown events in reverse order
 */
export function setEventKeysDesktopShiftTab(that: ModalOptionsFormComponent, document): void {
    if (!isPlatformBrowser(this.platformId)) {
    return;
  }
  if (!that.events.isDesktopShiftTabPress) { return }
  for (let i = that.formControlsInputId.length - 1; i > 0; i--) {
    const currentId = that.formControlsInputId[i]
    const inpt = document.getElementById(currentId)
    if (!inpt) {
      that.logger.info(`element with id ${currentId} not found`)
      continue
    }
    inpt.addEventListener('keydown', (event) => {
      shiftTabHandler(that, event, i)
    })

  }
}

/**
 * event for terms of use (first element of list)
 *
 * for returning on shift+tab to correct input in form (latest)
 *
 * impl is almost the same as for shift + tab on inputs
 */
export function setTermsOfUseReturnTab(that: ModalOptionsFormComponent, document): void {
    if (!isPlatformBrowser(this.platformId)) {
    return;
  }
  if (!that.events.isDesktopShiftTabTermsPress) { return }
  const currentId = 'termOfUseEl'
  const inpt = document.getElementById(currentId)
  if (!inpt) {
    that.logger.info(`element with id ${currentId} not found`)
    return
  }
  inpt.addEventListener('keydown', (event) => {
    if (event.key === 'Tab' && event.shiftKey) {
      // that.logger.info('shift tab on input event')
      const lastId = that.formControlsInputId[that.formControlsInputId.length - 1]
      const el = document.getElementById(lastId)
      if (!el) {
        that.logger.info('no element')
        return
      }
      event.preventDefault()
      that.setRunTimerByTimeout(SESSION_TIMER_MINUTES)
      el.click()
      inputSelectAriaCheckActiveState(el.parentElement, true)
    }
  })
}


/**
 * set event to inputs go forward by enter + tab
 *
 * go through all inputs and set keydown events in direct order
 */
export function setEventKeysDesktopTabReturn(that: ModalOptionsFormComponent, document): void {
    if (!isPlatformBrowser(this.platformId)) {
    return;
  }
  if (!that.events.isDesktopEnterOrTabPress) { return }
  for (let i = 0; i < that.formControlsInputId.length - 1; i++) {
    const currentId = that.formControlsInputId[i]
    const inpt = document.getElementById(currentId)
    if (!inpt) {
      that.logger.info(`element with id ${currentId} not found`)
      continue
    }
    inpt.addEventListener('keydown', (event) => {
      enterAndTabHandler(that, event, i)
    })

  }
}


/**
 * set mobile Enter event to all inputs;
 *
 * stop after cityInput
 */
export function setEventKeysMobileReturn(that: ModalOptionsFormComponent, document): void {
    if (!isPlatformBrowser(this.platformId)) {
    return;
  }
  if (!that.events.isMobileEnterNext) { return }
  for (let i = 0; i < that.formControlsInputId.length - 1; i++) {
    const currentId = that.formControlsInputId[i]
    const inpt = document.getElementById(currentId)
    if (!inpt) {
      that.logger.info(`element with id ${currentId} not found`)
      continue
    }
    inpt.addEventListener('keydown', (event) => {
      if (event.key === 'Enter') {
        that.logger.info('enter on input event')
        const nextId = that.formControlsInputId[i + 1]
        const el = document.getElementById(nextId)
        if (!el) {
          that.logger.info('no element')
          return
        }

        if (nextId === 'zipCodeInput') {
          return
        }

        event.preventDefault()
        that.setRunTimerByTimeout(SESSION_TIMER_MINUTES)
        el.click()
        if (nextId === 'ssnInputId') {
          inputAriaCheckActiveStateSSN(el.parentElement.parentElement, true)
          return
        }
        inputSelectAriaCheckActiveState(el.parentElement, true)
      }
    })

  }
}

/**
 * set , and . preventor to amount input
 */
// export function setEventKeyPressAmount(that: ModalOptionsFormComponent, document): void {
//   if (!that.events.isCommaPointAmountPreventor) { return }
//   const inpt = document.getElementById('amount_i')
//   inpt.addEventListener('keypress', (event) => {
//     if (event.key === ','
//       || event.key === '.'
//     ) {
//       event.preventDefault()
//       return
//     }
//   })
// }

/**
 * @returns modified string || null
 */
export function capitalizeFirstLetter(str: string): string {
  if (!str) { return null }
  if (str.length < 1) { return str }
  return str.charAt(0).toUpperCase() + str.slice(1)
}

/**
 * split string to words, and cap all words first letters
 * @returns modified string || null
 */
export function capitalizeAllFirstLetters(str: string): string {
  if (!str) { return null }
  if (str.length < 1) { return str }
  return str.split(' ').map(x => capitalizeFirstLetter(x)).join(' ')
}

/**
 * set valueChanges events on make first letters capital
 */
export function setUpperFirstLettersSubscribes(that: ModalOptionsFormComponent, document): void {
  if (!that.events.isValueChangesCapitalize) { return }
  const toUpperArr = ['firstName', 'secondName', 'address', 'city']
  for (const key of toUpperArr) {
    // that.logger.info('subscribe')
    that.loanForm.get(key).valueChanges.subscribe(val => {
      if (!val || val.length === 0) {
        return
      }
      that.setRunTimerByTimeout(SESSION_TIMER_MINUTES)
      let newVal
      newVal = capitalizeAllFirstLetters(val)
      if (val !== newVal) {
        that.loanForm.get(key).setValue(newVal)
      }
    })
  }
}

/**
 * on focusout set hyphens on mobile input
 */
export function setFormMobileAfterChangeAllHyphens(that: ModalOptionsFormComponent, document): void {
    if (!isPlatformBrowser(this.platformId)) {
    return;
  }
  if (!that.events.isFocusOutMobileSetHyphens) { return }
  const inpt = document.getElementById('mobileInputId')
  inpt.addEventListener('focusout', (event: any) => {
    const val = event.target.value
    if (!val || val.length === 0) {
      return
    }
    const newVal = mobileHyphensSetInstead(val)
    if (val !== newVal) {
      that.loanForm.get('mobile').setValue(newVal)
    }
    fixMobileValidation(that, newVal)
  })
}

/**
 * ad-hoc fix for ssn validation after copy-paste (ICW-383)
 *
 * use regex match for value, if matching remove all errors
 */
function fixSocSecValidation(that: ModalOptionsFormComponent, newVal: string) {
  const socNumberValidation = /^\d{3}-\d{2}-\d{4}$/
  const found = newVal ? newVal.match(socNumberValidation) : undefined
  if (found) {
    that.loanForm.get('socNumber').setErrors(null)
  }
}

/**
 * ad-hoc fix for mobile validation after copy-paste (7/8/2021 review #5)
 *
 * use regex match for value, if matching remove all errors
 */
function fixMobileValidation(that: ModalOptionsFormComponent, newVal: string) {
  const mobileValidation = /^\d{3}-\d{3}-\d{4}$/
  const found = newVal ? newVal.match(mobileValidation) : undefined
  if (found) {
    that.loanForm.get('mobile').setErrors(null)
  }
}

/**
 * on focusout set hyphens on ssn
 */
export function setSSNAfterChangeAllHyphens(that: ModalOptionsFormComponent, document): void {
    if (!isPlatformBrowser(this.platformId)) {
    return;
  }
  if (!that.events.isFocusOutSSNSetHyphens) { return }
  const inpt = document.getElementById('ssnInputId')
  inpt.addEventListener('focusout', (event: any) => {
    const val = event.target.value
    if (!val || val.length === 0) {
      return
    }
    const newVal = ssnHyphensSetInstead(val)
    if (val !== newVal) {
      that.loanForm.get('socNumber').setValue(newVal)
    }
    fixSocSecValidation(that, newVal)
  })

}

/**
 * on focusout set dashes on date input
 */
export function setDateAfterChangeAllDashes(that: ModalOptionsFormComponent, document): void {
    if (!isPlatformBrowser(this.platformId)) {
    return;
  }
  if (!that.events.isFocusOutDateSetDashes) { return }
  const inpt = document.getElementById('dobInputId')
  inpt.addEventListener('focusout', (event: any) => {
    const val = event.target.value
    if (!val || val.length === 0) {
      return
    }
    const newVal = dateDashesSetInstead(val)
    that.setRunTimerByTimeout(SESSION_TIMER_MINUTES)
    if (val !== newVal) {
      that.logger.info(val)
      that.logger.info(newVal)
      that.loanForm.get('dateOfBirth').setValue(newVal)
    }
  })

}

/**
 * on valueChanges add active input area to inputs in list
 */
export function showAllInvalid(that: ModalOptionsFormComponent, document): void {
    if (!isPlatformBrowser(this.platformId)) {
    return;
  }
  if (!that.events.isValueChangesSetActiveArea) { return }
  // const allInputsFormControls = ['firstName', 'secondName',
  // 'address', 'city', 'zipCode', 'socNumber',
  // 'dateOfBirth', 'mobile', 'income']
  const allInputsFormControls = ['firstName', 'secondName',
  'address', 'city', 'zipCode', 'socNumber',
  'dateOfBirth', 'mobile', 'income']

  for (const [idx, controlName] of allInputsFormControls.entries()) {
    that.loanForm.get(controlName).valueChanges.subscribe(val => {
      if (!val || val.length === 0) {
        return
      }
      // SKIP removing from DOB after errors
      if (that.ssn_dobErrors && controlName === 'dateOfBirth') {
        return
      }
      const inpt = document.getElementById(that.formControlsInputId[idx])
      // if (inpt.parentElement.classList.contains('invalid')) {
      setTimeout(() => {
        inpt.parentElement.classList.remove('input-area__inactive')
        inpt.parentElement.classList.add('input-area__active')
        if (inpt.parentElement.classList.contains('input-area__inactive')) {
          inpt.parentElement.classList.remove('input-area__inactive')
        }
        // that.logger.info(inpt.parentElement.classList)
        that.setRunTimerByTimeout(SESSION_TIMER_MINUTES)
      }, 100)
    })
  }
}



/**
 * go through all form controls and touch them (also focusing)
 */
export function goThroughAndTouch(that: ModalOptionsFormComponent, document): void {
    if (!isPlatformBrowser(this.platformId)) {
    return;
  }
  const allInputsFormControls = ['amount', 'firstName', 'secondName',
  'address', 'city', 'zipCode', 'socNumber',
  'dateOfBirth', 'mobile', 'income']

  for (const [idx, controlName] of allInputsFormControls.entries()) {
    const control = that.loanForm.get(controlName)
    const val = control.value
    // that.loanForm.get(controlName).valueChanges.subscribe(val => {
    if (!val || val.length === 0) {
      continue
    }
    control.markAsTouched()
    const el = document.getElementById(that.formControlsInputId[idx])
    that.setRunTimerByTimeout(SESSION_TIMER_MINUTES)
    if (el) {
      el.focus()
    }
  }
}
